import React, { useEffect } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useTitle } from '../../../hooks';
import theme from '../../../theme';
import PricingMobile from './PricingMobile';
import PricingDesktop from './PricingDesktop';
import { selectProductList } from '../../../store/modules/products/selectors';
import { getProductListRequest } from '../../../store/modules/products/actions';

const Pricing = () => {
  useTitle('Pricing');
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { data: fullProductList } = useSelector(selectProductList);

  useEffect(() => {
    if (!fullProductList) {
      dispatch(getProductListRequest());
    }
  }, [dispatch, fullProductList]);

  return (
    <>
      {isMobile ? <PricingMobile /> : <PricingDesktop />}
    </>
  );
};

export default Pricing;
